import React from 'react';
import styled from 'styled-components';
import CardClientsProfile from './cardClients-profile'
import StateDispatch from './contextInfo'

const Clients = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;

`
const Title = styled.div`
  font-size: 1.2em;
  font-weight: 400; 
  line-height: 100%;
  letter-spacing: 0.05em;
  padding-top: 1.2rem;
  margin-bottom: 0.4rem;
  color: #373D3F;
`
const Profiles = styled.div`
  flex-grow: 1;
  align-self: stretch;

  display: flex;
  flex-direction: column;
  justify-content: space-around;
`

export default function CardClients(props) {
  const info = React.useContext(StateDispatch)

  let clientsMap = [];
  if (info.length > 0 && props.title === 'New Clients') {
    clientsMap = [info[0], info[1], info[2], info[3]].sort((a,b) => b.clientfrom - a.clientfrom)
    for (let i = 4; i < info.length; i++) {
      if (info[i].clientfrom > clientsMap[3].clientfrom) {
        clientsMap[3] = info[i]
        clientsMap.sort((a,b) => b.clientfrom - a.clientfrom)
      }
    }
  } else if (info.length > 0 && props.title === 'Top Clients') {
    clientsMap = [info[0], info[1], info[2], info[3]].sort(compare)

    let lastClient = clientsMap[3]
    let lastClientTotal = 0;

    for (let i = 0; i < lastClient.orders.length; i++) {
      let nPrice = Number(lastClient.orders[i].price.replace(/[^0-9.-]+/g,""))
      let curOrder = nPrice * lastClient.orders[i].days
      lastClientTotal = lastClientTotal + curOrder
    }

    for (let j = 4; j < info.length; j++) {
      let currentClient = info[j]
      let currentClientTotal = 0;

      for (let i = 0; i < currentClient.orders.length; i++) {
        let nPrice = Number(currentClient.orders[i].price.replace(/[^0-9.-]+/g,""))
        let curOrder = nPrice * currentClient.orders[i].days
        currentClientTotal = currentClientTotal + curOrder
      }

      if (currentClientTotal > lastClientTotal) {
        lastClient = currentClient
        lastClientTotal = currentClientTotal
        clientsMap[3] = currentClient
        clientsMap.sort(compare)
      }
    }


    function compare(a,b) {
      let totA = 0;
      let totB = 0;

      for (let i = 0; i < a.orders.length; i++) {
        let nPrice = Number(a.orders[i].price.replace(/[^0-9.-]+/g,""))
        let curOrder = nPrice * a.orders[i].days
        totA = totA + curOrder
      }

      for (let i = 0; i < b.orders.length; i++) {
        let nPrice = Number(b.orders[i].price.replace(/[^0-9.-]+/g,""))
        let curOrder = nPrice * b.orders[i].days
        totB = totB + curOrder
      }

      if (totA < totB) return 1
      else if (totA > totB) return -1
      else return 0
    }
  }


  return (
    <Clients>
      <Title>{props.title}</Title>
      <Profiles>
        <CardClientsProfile type={props.title} client={clientsMap[0]}></CardClientsProfile>
        <CardClientsProfile type={props.title} client={clientsMap[1]}></CardClientsProfile>
        <CardClientsProfile type={props.title} client={clientsMap[2]}></CardClientsProfile>
        <CardClientsProfile type={props.title} client={clientsMap[3]}></CardClientsProfile>
      </Profiles>
    </Clients>
  )
}